var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBurger = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4167 8.33301H1.58333C0.708882 8.33301 0 9.04189 0 9.91634V10.083C0 10.9575 0.708882 11.6663 1.58333 11.6663H28.4167C29.2911 11.6663 30 10.9575 30 10.083V9.91634C30 9.04189 29.2911 8.33301 28.4167 8.33301Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4167 16.667H1.58333C0.708882 16.667 0 17.3759 0 18.2503V18.417C0 19.2914 0.708882 20.0003 1.58333 20.0003H28.4167C29.2911 20.0003 30 19.2914 30 18.417V18.2503C30 17.3759 29.2911 16.667 28.4167 16.667Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4167 0H1.58333C0.708882 0 0 0.708882 0 1.58333V1.75C0 2.62445 0.708882 3.33333 1.58333 3.33333H28.4167C29.2911 3.33333 30 2.62445 30 1.75V1.58333C30 0.708882 29.2911 0 28.4167 0Z",
    fill: "#343434"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burger.f01e7bce.svg";
export { ForwardRef as ReactComponent };